import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsuarioEstado } from '../../models/usuario-model';
import { DatosUsuariosService } from '../../services/datos-usuarios.service';
import { ConversionDatosApiService } from 'src/app/shared/services/conversion-datos-api.service';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';

@Component({
  selector: 'app-usuarios-filter-details',
  templateUrl: './usuarios-filter-details.component.html',
  styleUrls: ['./usuarios-filter-details.component.css']
})
export class UsuariosFilterDetailsComponent implements OnInit {

  usuarioEstados: DesplegableData[];
  @Output() estadoSeleccionado: EventEmitter<string> = new EventEmitter<string>();

  constructor(private datosUsuariosService: DatosUsuariosService,
              private _snackBar: MatSnackBar,
              private conversionDatosApiService: ConversionDatosApiService) { }

  ngOnInit(): void {
    this.getEstadosUsuario();
  }

  getEstadosUsuario(){
    this.datosUsuariosService.getEstadosUsuario().subscribe(
      next => {
        this.usuarioEstados = this.conversionDatosApiService.mapCodigoAIdEntrada(next);
      },
      error => {
        if(error.status!==401) this._snackBar.open(error.message, 'Cerrar',{duration: 4000});
      }
    )
  }

  filterEstado(event: any){
    this.estadoSeleccionado.emit(event.desc)
    // this.estadoSeleccionado.emit(event.target.value)
  }

}
